import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Fragment } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { PanelEnum } from '@ui/interfaces'
import { AddStepWizard } from '@ui/pages/pipelinesWorkflow/components/PipelineActionModal/AddStepWizard'
import { AssignSourcesWizard } from '@ui/pages/pipelinesWorkflow/components/PipelineActionModal/AssignSourcesWizard'
import { DestinationWizard } from '@ui/pages/pipelinesWorkflow/components/PipelineActionModal/DestinationWizard'
import { useNodeAndEdgeStore } from '@ui/stores'

export function Modal() {
  const displayModal = useNodeAndEdgeStore(useShallow((state) => state.displayModal))
  const setDisplayModal = useNodeAndEdgeStore(useShallow((state) => state.setDisplayModal))
  const setCurrentNodeId = useNodeAndEdgeStore(useShallow((state) => state.setCurrentNodeId))

  const onClose = () => {
    setDisplayModal(PanelEnum.HIDDEN)
    setCurrentNodeId(null)
  }

  const open = [PanelEnum.ADD_STEP, PanelEnum.SOURCES, PanelEnum.DESTINATIONS].includes(displayModal)

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex w-full max-w-lg pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full">
                <Dialog.Panel className="pointer-events-auto w-screen">
                  <div className="flex h-full flex-col overflow-y-scroll bg-slate-50 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <div className="flex flex-row-reverse items-end justify-between">
                        <div className="ml-3 flex h-7 items-center pt-4">
                          <button type="button" className="rounded-md hover:text-gray-500" onClick={onClose}>
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative flex-1 px-4 sm:px-6">
                      {displayModal === PanelEnum.ADD_STEP && <AddStepWizard />}
                      {displayModal === PanelEnum.SOURCES && <AssignSourcesWizard />}
                      {displayModal === PanelEnum.DESTINATIONS && <DestinationWizard />}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
